// extracted by mini-css-extract-plugin
export default {"PostCreate":"qw_a big_qt big_a big_w big_ea"};